import { Component, Inject, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder, UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SelectInputOption } from '@vendasta/galaxy/input';
import {
  SEARCH_RADIUS_BIG_CITY,
  SEARCH_RADIUS_LOCAL,
  SEARCH_RADIUS_SMALL_CITY,
  SEARCH_RADIUS_XL_CITY,
  SEARCH_RADIUS_METRO_AREA,
  SEARCH_RADIUS_REGION,
  SEODataSearchRadiusTypes,
  SeoDataSearchRadiusType,
} from '../../local-seo';

const defaultOptions = [
  {
    label: 'LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.LOCAL',
    value: SEARCH_RADIUS_LOCAL,
  },
  {
    label: 'LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.SMALL_CITY',
    value: SEARCH_RADIUS_SMALL_CITY,
  },
  {
    label: 'LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.BIG_CITY',
    value: SEARCH_RADIUS_BIG_CITY,
  },
  {
    label: 'LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.XL_CITY',
    value: SEARCH_RADIUS_XL_CITY,
  },
  {
    label: 'LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.METRO_AREA',
    value: SEARCH_RADIUS_METRO_AREA,
  },
  {
    label: 'LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.REGION',
    value: SEARCH_RADIUS_REGION,
  },
];

@Pipe({
  name: 'mileToKilometer',
  standalone: false,
})
export class MileToKilometerPipe implements PipeTransform {
  private readonly conversionFactor = 1.60934;
  transform(value: string, kilometersTranslationKey: string): string {
    const parts = value.split(' ');
    const number = parseFloat(parts[0]);
    const unit = parts[1];
    if (unit === kilometersTranslationKey) {
      const kilometers = number * this.conversionFactor;
      return `${Math.round(kilometers)} ${unit}`;
    }

    return `${number} ${unit}`;
  }
}

@Component({
  selector: 'local-seo-settings-dialog',
  templateUrl: './local-seo-settings-dialog.component.html',
  styleUrls: ['./local-seo-settings-dialog.component.scss'],
  standalone: false,
})
export class LocalSeoSettingsDialogComponent {
  seoSettingsRadiusForm: UntypedFormControl;
  options: SelectInputOption[];
  selectedMapUnit: string;
  selectedValue: number;
  translatedMapUnitsKMS: string;
  isFullSearchEnabled: boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { mapRadius: number; mapUnits: string; isFullSearchEnabled: boolean },
    public dialogRef: MatDialogRef<LocalSeoSettingsDialogComponent>,
    private fb: FormBuilder,
    private translateService: TranslateService,
  ) {
    this.options = defaultOptions;
    this.isFullSearchEnabled = data.isFullSearchEnabled;
    this.selectedValue = SEARCH_RADIUS_LOCAL;

    this.translateService.get('LOCAL_SEO.SELECT_LOCAL_SEARCH_RADIUS.KMS').subscribe((translation) => {
      this.translatedMapUnitsKMS = translation;
    });

    const radiusValue = SEODataSearchRadiusTypes.includes(data.mapRadius as SeoDataSearchRadiusType)
      ? data.mapRadius
      : SEARCH_RADIUS_LOCAL;

    if (data.mapRadius && data.mapRadius > 0) {
      this.selectedValue = radiusValue;
    }

    this.seoSettingsRadiusForm = new UntypedFormControl();
    this.selectedMapUnit = data.mapUnits;
    this.seoSettingsRadiusForm.setValue(radiusValue);
  }

  closeModal(save: boolean): void {
    const result = {
      mapRadius: this.selectedValue,
      mapUnits: this.selectedMapUnit,
      isFullSearchEnabled: this.isFullSearchEnabled,
    };
    this.dialogRef.close(save ? result : undefined);
  }

  setMapUnit(selectedMapUnit: string): void {
    this.selectedMapUnit = selectedMapUnit;
  }
}
